import React, { useEffect, useState } from "react";

import { Col, Row, Typography, Layout, Card, Space, Image, Button } from "antd";
import { HeartFilled, HeartOutlined } from "@ant-design/icons";
// import book1 from "../../assets/new-book1.png";
// import book2 from "../../assets/new-book2.png";
// import book3 from "../../assets/new-book3.png";
// import book4 from "../../assets/new-book4.png";
// import { ImageUrl } from "../../helpers/Function";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { ImageUrl } from "../../helpers/Function";
import { FaArrowLeft } from "react-icons/fa";

const books = [
    {
        id: 1,
        title: "Harry Potter",
        isFav: false,
        price: "$15.00",
        author: "J.K Rowling",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book1.png",
    },
    {
        id: 2,
        title: "Realm of Ruins",
        isFav: false,
        price: "$20.00",
        available: "Available",
        author: "Hannah West",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book2.png",
    },
    {
        id: 3,
        title: "Dark Gathering",
        isFav: false,
        price: "$15.00",
        author: "Leigh Bardugo",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book3.png",
    },
    {
        id: 4,
        title: "Thalgor’s Witch",
        isFav: false,
        price: "$20.00",
        author: "Nancy Holland",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book4.png",
    },
    {
        id: 5,
        title: "Harry Potter",
        isFav: false,
        price: "$15.00",
        author: "J.K Rowling",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book5.png",
    },
    {
        id: 6,
        title: "Realm of Ruins",
        isFav: false,
        price: "$20.00",
        author: "Hannah West",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book3.png",
    },
    {
        id: 7,
        title: "Dark Gathering",
        isFav: false,
        price: "$15.00",
        author: "Leigh Bardugo",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book2.png",
    },
    {
        id: 8,
        title: "Thalgor’s Witch",
        isFav: false,
        price: "$20.00",
        author: "Nancy Holland",
        days: "for 3 days",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio. Lorem ipsum dolor sit amet,",
        image: "new-book5.png",
    },

];



function AboutUs() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.user.userToken);
    const [loading, setLoading] = useState(false);
    const [productDetails, setProductDetails] = useState(null);
    const { id } = useParams();
    const [booksdata, setBooksdata] = useState(
        books.find((item) => item.id == id)
    );
    const location = useLocation();
    const index = location?.state.index;


 useEffect(() => { window.scrollTo(0, 0); }, []);
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Row
                className="blueBackground-old booksbanner"
                style={{
                    height: "55vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography.Title
                    className="fontFamily1 aboutbanner-content newfont"
                    style={{ fontSize: "46px", color: "#000" }}
                >
                    {<> Book Details</>}
                </Typography.Title>
            </Row>

            {/* section 2 */}
            <Row
                className="whiteBackground"
                style={{ backgroundColor: "white", justifyContent: "center" }}
            >
                <Col xs={24} md={20}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",

                            padding: "50px 20px",
                        }}
                    >
                        <div style={{ marginBottom: 20, marginLeft: 10 }}>
                            <FaArrowLeft
                                style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
                                onClick={() => navigate(-1)}
                            />
                        </div>
                        <Card
                            className="infoBox"
                            bordered={false}
                            style={{
                                width: "100%",
                                // padding: "20px",
                            }}
                        >
                            <div className="detail-box items-center book-detail-page">
                                <div
                                    style={{
                                        position: "relative",
                                        minWidth: "300px",
                                        width: "fit-content",
                                    }}
                                    className="book-detail-page-img"
                                >
                                    <span
                                        className="cursor-pointer"
                                        onClick={() =>
                                            navigate("/libraryAccess/" + booksdata?.id)
                                        }
                                    >
                                        {/* {booksdata.image} */}
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl(booksdata.image)}
                                            style={{
                                                Width: "100%",
                                                maxHeight: "480px",
                                                objectFit: "cover",
                                                borderRadius: "10px",
                                                objectPosition: "center",
                                              }}
                                        />
                                    </span>
                                </div>
                                <div className="detail-box2">
                                    <h6 className="text-green-700 text-lg">
                                        {booksdata.available}
                                    </h6>
                                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                        <h3 className="venue-title fontFamily1" style={{
                                            fontSize: "35px",
                                            fontWeight: 600,
                                            color: "black",
                                            textAlign: "left",
                                        }}>{booksdata.title}</h3>
                                        <h3 className="detail-price" style={{
                                            fontSize: "25px",
                                            fontWeight: 600,
                                            color: "black",
                                            textAlign: "left",
                                        }}>
                                            {booksdata.price}{" "}
                                            <span style={{ fontSize: "14px" }}>
                                                {booksdata.days}
                                            </span>
                                        </h3>
                                    </div>

                                    <span className="fontFamily1 author" style={{
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "left",
                                    }}>{booksdata.author}</span>

                                    <h5 className="heading-20" style={{
                                        fontSize: "30px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "left",
                                    }}>Details:</h5>
                                    <p className="detail-p pb-3 fontFamily1"
                                        style={{ fontSize: "16px", color: "grey", textAlign: "left" }}>{booksdata.description}</p>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="loginButton"
                                      onClick={() => navigate("/checkout")}
                                    >
                                        {loading ? "Loading..." : "Buy Now"}
                                    </Button>

                                </div>
                            </div>
                        </Card>
                    </div>
                </Col>
            </Row>
        </Layout>
    );
}

export default AboutUs;
